/** @jsxImportSource ../../i18n */
import React from 'react';
import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react';
import { cx } from '../../theme/cx';

const ALIGN = { left: 'text-left', right: 'text-right', center: 'text-center' };

export const Table = ({ className, containerClassName, children, ...rest }) => (
  <div className={cx('min-w-0 overflow-x-auto', containerClassName)}>
    <table className={cx('w-full border-separate border-spacing-0 text-left text-body-sm', className)} {...rest}>
      {children}
    </table>
  </div>
);

export const THead = ({ children, className }) => <thead className={className}>{children}</thead>;

export const TBody = ({ children, className }) => <tbody className={className}>{children}</tbody>;

const SORT_LABEL = { asc: 'ascending', desc: 'descending' };

export const Th = ({ children, align = 'left', sortable = false, sortDirection, onSort, className, ...rest }) => {
  const SortIcon = sortDirection === 'asc' ? ArrowUp : sortDirection === 'desc' ? ArrowDown : ChevronsUpDown;
  return (
    <th
      scope="col"
      aria-sort={sortable ? SORT_LABEL[sortDirection] || 'none' : undefined}
      className={cx('whitespace-nowrap border-b border-line px-3 pb-3 pt-1 text-eyebrow font-semibold uppercase text-fg-subtle first:pl-0 last:pr-0', ALIGN[align], className)}
      {...rest}
    >
      {sortable ? (
        <button
          type="button"
          onClick={onSort}
          className={cx('inline-flex items-center gap-1 uppercase tracking-[inherit] transition-colors hover:text-fg', sortDirection && 'text-fg-body', align === 'right' && 'flex-row-reverse')}
        >
          {children}
          <SortIcon size={12} aria-hidden="true" className={sortDirection ? 'text-gold-400' : 'text-fg-faint'} />
        </button>
      ) : children}
    </th>
  );
};

export const Tr = ({ children, className, ...rest }) => (
  <tr className={cx('group/row transition-colors duration-150 hover:bg-surface-2/60', className)} {...rest}>
    {children}
  </tr>
);

export const Td = ({ children, align = 'left', numeric = false, className, ...rest }) => (
  <td
    className={cx('border-b border-line/70 px-3 py-3.5 align-middle text-fg-body first:pl-0 last:pr-0 group-last/row:border-b-0', numeric && 'num', ALIGN[align], className)}
    {...rest}
  >
    {children}
  </td>
);
